/* eslint-disable no-undef */
export default class Environment {
    static isDevelopment = () => process.env.NODE_ENV === 'development';
}
